export type AppEnvironment = typeof __APP_ENVIRONMENT__

type EnvironmentBadge = {
  className: string
  label: string
}

const ENVIRONMENT_BADGES = {
  development: {
    className: 'bg-black dark:bg-amber-500',
    label: 'DEV'
  },
  staging: {
    className: 'bg-violet-600 dark:bg-violet-500',
    label: 'PRE'
  },
  production: null
} satisfies Record<AppEnvironment, EnvironmentBadge | null>

export const APP_ENVIRONMENT = __APP_ENVIRONMENT__
export const APP_ENVIRONMENT_BADGE = ENVIRONMENT_BADGES[APP_ENVIRONMENT]
